/**
 * AI Controller - manages AI faction behavior using behavior trees
 */

import type { World } from '@/core/ecs/World';
import type { FactionManager } from '@/game/factions/FactionManager';
import type { TerritorySystem } from '@/game/systems/TerritorySystem';
import type { FactionId } from '@/types';
import { AIBrain } from './AIBrain';

export class AIController {
  private world: World;
  private factionManager: FactionManager;
  private territorySystem: TerritorySystem;
  private aiBrains: Map<FactionId, AIBrain> = new Map();

  constructor(world: World, factionManager: FactionManager, territorySystem: TerritorySystem) {
    this.world = world;
    this.factionManager = factionManager;
    this.territorySystem = territorySystem;
  }

  registerAI(factionId: FactionId): void {
    const brain = new AIBrain(
      this.world,
      this.factionManager,
      this.territorySystem,
      factionId
    );
    this.aiBrains.set(factionId, brain);
  }

  unregisterAI(factionId: FactionId): void {
    this.aiBrains.delete(factionId);
  }

  update(deltaTime: number): void {
    for (const [factionId, brain] of this.aiBrains) {
      const factionState = this.factionManager.getFactionState(factionId);
      if (!factionState || factionState.isDefeated || factionState.isPlayer) continue;

      brain.update(deltaTime);
    }
  }

  getActiveFactionCount(): number {
    return this.aiBrains.size;
  }
}
